import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u54",
  "use": "icon-u54-usage",
  "viewBox": "0 0 326 2",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 326 2\" id=\"icon-u54\">\n  <g transform=\"matrix(1 0 0 1 -575 -251 )\">\n    <path d=\"M 575 251.5  L 900 251.5  \" stroke-width=\"1\" stroke=\"#d4d4d4\" fill=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/u54.svg
// module id = V8LN
// module chunks = 23